import { render, staticRenderFns } from "./SessionUserDisplay.vue?vue&type=template&id=c5ba85fe&scoped=true&"
import script from "./SessionUserDisplay.vue?vue&type=script&lang=js&"
export * from "./SessionUserDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SessionUserDisplay.vue?vue&type=style&index=0&id=c5ba85fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba85fe",
  null
  
)

export default component.exports